import React from 'react';
import { PrismicLink } from 'components/PrismicLink';

const LogInLogOut = ({
    loginLabel,
    logoutLabel,
    loginLink,
    className,
    isLoggedIn,
    logOut,
}: {
    loginLabel: string;
    logoutLabel: string;
    loginLink: any;
    className: string;
    isLoggedIn: boolean;
    logOut: () => void;
}) =>
    !isLoggedIn ? (
        <PrismicLink label={loginLabel} link={loginLink} className={className} />
    ) : (
        <a className={className} onClick={logOut}>
            {logoutLabel}
        </a>
    );

export default LogInLogOut;
